import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, take } from 'rxjs';
import {
  ClearingTicketCustomService,
  OwnerScopeDto,
} from '@adlatus-gui/domain/clearing-custom';

@Injectable({ providedIn: 'root' })
export class OwnerScopeService {
  private ownerScopeSubject?: ReplaySubject<OwnerScopeDto>;
  private isLoading = false;
  private isLoaded = false;

  constructor(
    private readonly clearingTicketCustomService: ClearingTicketCustomService
  ) {}

  getOwnerScope(): Observable<OwnerScopeDto> {
    if (!this.ownerScopeSubject) {
      this.ownerScopeSubject = new ReplaySubject<OwnerScopeDto>(1);
    }

    const ownerScope$ = this.ownerScopeSubject.asObservable();

    if (!this.isLoaded && !this.isLoading) {
      this.isLoading = true;
      this.clearingTicketCustomService
        .getCurrentOwnerScope()
        .pipe(take(1))
        .subscribe({
          next: (ownerScope) => {
            this.isLoading = false;
            this.isLoaded = true;
            this.ownerScopeSubject?.next(ownerScope);
            this.ownerScopeSubject?.complete();
          },
          error: (error) => {
            this.isLoading = false;
            this.isLoaded = false;
            this.ownerScopeSubject?.error(error);
            this.ownerScopeSubject = undefined;
          },
        });
    }

    return ownerScope$;
  }
}
